import { useQuery } from "@tanstack/react-query"
import { getExternalCurrencyRequests } from "../api/externalCurrency"

export const useExternalCurrencyRequestsQuery = () => {
  return useQuery({
    queryKey: ["externalCurrencyRequests"],
    queryFn: () => getExternalCurrencyRequests(),
  })
}